import * as React from 'react'

import { Dispatch } from 'redux'
import { connect } from 'react-redux'

import { Store } from '../../reducers/index'
import { Action } from '../../actions/types'
import { selectSpaceType } from '../../actions/project'

import Selector from './SpaceTypeSelector'
import { getActiveSpaceType } from '../../reducers/project'

type Props = {
  selectedType: string
  select: (typeId: string) => Action
}

const SpaceTypeSelect: React.SFC<Props> = props => (
  <Selector selectedType={props.selectedType} select={props.select} />
)

const mapStateToPros = (state: Store.Complete) => ({
  selectedType: getActiveSpaceType(state)
})

const mapDispatchToProps = (dispatch: Dispatch<Store.Complete>) => ({
  select: (typeId: string) => dispatch(selectSpaceType(typeId))
})

export default connect(mapStateToPros, mapDispatchToProps)(SpaceTypeSelect)



// WEBPACK FOOTER //
// ./src/Components/SpaceTypeSelect/index.tsx